import { createDrawingsFile } from "./caxa/directive/createDrawingsFile.js";
import { ExternalType } from "./type.js";
function externalCreateDrawingsFile(arg, type = ExternalType.caxa) {
  switch (type) {
    case ExternalType.caxa:
      return createDrawingsFile(arg);
    default:
      throw new Error(`\u8BE5\u65B9\u6CD5\uFF0C\u6682\u4E0D\u652F\u6301${type}\u7C7B\u578B\u7684\u5916\u90E8\u7CFB\u7EDF`);
  }
}
export { externalCreateDrawingsFile };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/externalCreateDrawingsFile.js